import { MembershipAddressModel } from 'model/screensModels/membership/MembershipAddressModel';
import { MembershipModel } from 'model/screensModels/membership/MembershipModel'
import React, { useEffect, useReducer, useState } from 'react'
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import './CompanyBranches.scss'
import { UtilService } from 'services/shared/UtilService';
import { msgTypes } from 'constants/msgTypes';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { useNavigate } from 'react-router-dom';
import { RouteType } from 'constants/RouteType';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import { RequestModel } from 'model/utilModels/RequestModel';
import { MemberLoginService } from 'services/menu/dashboard/MemberLoginService';

const CompanyBranches = ({ companyData }) => {

  const [branchList, setBranchList] = useState<MembershipModel[]>([]);
  const [loginCompanyId, setLoginCompanyId] = useState(new MembershipModel());
  const navigate = useNavigate();

  useEffect(() => {
    if (companyData.companyId !== '') {
      //setCompanyDetails(companyData);
      loadCompanyBranches();
      getLoginUserDetails();
    }
  }, [companyData])

  const loadCompanyBranches = async () => {
    const requestData = new MembershipModel();
    requestData.companyId = companyData.companyId;
    const res = await UtilService.getCompanyDetailsByCompanyId(requestData);
    // console.log("Company Branch is", res)
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setBranchList(res.data)
      } else {
        setBranchList([]);
      }
    }
  }

  const getLoginUserDetails = async() =>{
    const loginCompanyDetails = JSON.parse(await LocalStorageService.getUserDetails());
    setLoginCompanyId(loginCompanyDetails.companyId)
  }

  const editBranchDetails = (companyId) => {
    navigate(RouteType.HOME + RouteType.UPDATE_MEMBERSHIP, { state: { companyId: companyId, addBranch: false } });
  }

  const handleOnClick = async (companyId) => {
    const role = await LocalStorageService.getUserRole();
    if (role === msgTypes.USER_TYPE.MEMBER) {
      await saveVisitorDetails(companyId);
    }
    
    navigate(RouteType.HOME + RouteType.BRANCH_COMPANY_PROFILE, {
      state: { companyId },
    });
  };
  


  // const visitorRequestData = async (companyId) => {
  //   const data = new RequestModel();
     
  //   data.companyId = companyId;
  //   const userDetails = JSON.parse(await LocalStorageService.getUserDetails());

  //   const compnayRepresentative = userDetails.contactPerson.find(
  //     (person) => person.contactIsrepresentative === true
  //   );
  //   data.visitorProfileId = "";
  //   data.visitorId = compnayRepresentative.contactPersonId;
  //   const res = await MemberLoginService.getLoginDetails();
  //   const loginDetails = res?.data[0].loginDetails[res.data.length - 1];
  //   data.latitude = loginDetails.latitude;
  //   data.longitude = loginDetails.longitude;
  //   return data;
  // };


  const saveVisitorDetails = async (companyId) => {
    // const requestData = await visitorRequestData(companyId);
    const res = await UtilService.saveVisitorDetails(companyId);
  };



  return (
    <>
      {branchList.length > 0 && (
        <>
          <div className="row card--">
            <div className="col-12">
              <div className="card border-0">
                <div className="card-body px-3">
                  <h6>Company Branches</h6>
                <div className="row alternating-colors">
  {Array.isArray(branchList) && branchList.map((branch: MembershipModel, index) => (
    <div className="col-xl-4 col-md-6 col-sm-6" key={index}>
      <li className="index-branch bg-gray-100 p-3">
        <div className="branches-- justify-content-between mb-4">
          <div className="d-flex cursor-pointer" onClick={() => handleOnClick(branch.companyId)}>
            <div className="alternativ-icon">
              <CorporateFareIcon />
            </div>
            <div className="companies-name">
              <h6>{branch.companyName}</h6>
              <p className="text-sm company-p">{branch.stateName},&nbsp; {branch.countryName}</p>
              {/* <p className="text-sm company-p">{branch.stateName}</p> */}
            </div>
          </div>

          {loginCompanyId === companyData?.companyId && (
            <div className="edit-branch" onClick={() => editBranchDetails(branch.companyId)}>
              <DriveFileRenameOutlineIcon />
            </div>
          )}
        </div>

        <div className="alternating-margin">
          <p className="text-sm font-weight-bold mb-0"><EmailIcon /> Email: &nbsp;{branch.companyEmail}</p>
          <p className="text-sm font-weight-bold mb-0"><CallIcon /> Contact: &nbsp;{branch.primaryPhoneNumber}</p>
        </div>
      </li>
    </div>
  ))}
</div>

                </div>
              </div>
            </div>
          </div>

        </>
      )
      }
    </>
  )
}

export default CompanyBranches